import { combineReducers } from "redux";
import fauluCalculator from "./fauluLoanCalculator"
import scrolling from "./scrolling";
import auth from "./auth";

export const fauluLoanCalculatorStore = combineReducers({
    fauluCalculator,
    scrolling,
    auth
})